<template>
  <header>
    <div class="logo"></div>
    <div class="nav-center">
      <div class="nav-actions">
        <img @click="goBack()" src="../assets/back.gif" alt="" />
        <img @click="refreshPage()" src="../assets/refresh.gif" alt="" />
      </div>
      <span v-if="user.showLeads" @click="$router.push({ name: 'leads' })" :class="{ active: $route.name == 'leads' }">Leads</span>
      <span v-if="user.showQuotes" @click="$router.push({ name: 'quotes' })" :class="{ active: $route.name == 'quotes' || $route.name == 'quote' }">Quotes</span>
      <span v-if="user.showContacts" @click="$router.push({ name: 'companies' })" :class="{ active: $route.name == 'contacts' || $route.name == 'companies' }">Contacts</span>
      <span
        v-if="user.showGeneralReports"
        @click="showReportsMenu = !showReportsMenu"
        :class="{ active: ($route.name == 'customer-report' || $route.name == 'company-report' || $route.name == 'sales-impact-report') && !showReportsMenu, 'dropdown-toggle': true }">
        Reports
        <ReportsMenu v-if="showReportsMenu" @closeDropdown="showReportsMenu = false" />
      </span>
      <span
        v-if="!user.showGeneralReports && !user.showLeads && !user.showQuotes && !user.showContacts && user.showImpactReport"
        @click="$router.push({ name: 'sales-impact-report' })"
        :class="{ active: $route.name == 'sales-impact-report' }"
        >Sales Impact Report</span
      >
      <span v-if="user.admin || user.contactsAdmin || user.quotesAdmin" @click="$router.push({ name: 'admin' })" :class="{ active: $route.path.match('admin/') }">Admin</span>
    </div>
    <div class="nav-right">
      <div class="icon-container">
        <img v-if="sortedReminders.length" @click="showRemindersMenu = true" src="../assets/reminder.svg" alt="" />
        <RemindersMenu v-if="showRemindersMenu" @closeDropdown="showRemindersMenu = false" :reminders="sortedReminders" @selectReminder="selectReminder" />
      </div>
      <img v-if="user.showContacts || user.showLeads || user.showQuotes" @click="$router.push({ name: 'find-contractor' })" src="../assets/find-a-contractor.svg" alt="" />
      <div class="icon-container">
        <img @click="showVersionUpdates = true" src="../assets/help.gif" alt="" />
      </div>
      <div class="icon-container" v-click-outside="() => (showUserMenu = false)">
        <img @click="showUserMenu = true" src="../assets/user-profile.svg" alt="" />
        <UserMenu v-if="showUserMenu" @closeDropdown="showUserMenu = false" />
      </div>
      <VersionUpdates v-if="showVersionUpdates" @closePopup="showVersionUpdates = false" />
      <Reminder v-if="showReminder" :reminderid="showReminder" :reminders="sortedReminders" @closePopup="showReminder = null" />
      <SingleLead v-if="showSingleLead" />
    </div>
  </header>
  <Notification />
  <Alert />
</template>

<script>
import RemindersMenu from './RemindersMenu.vue';
import ReportsMenu from './ReportsMenu.vue';
import VersionUpdates from './VersionUpdates.vue';
import Notification from './Notification.vue';
import Alert from './Alert.vue';
import useReminderQuery from '../composables/useReminderQuery';
import Reminder from './Reminder.vue';
import useCurrentUser from '@/composables/useCurrentUser';
import SingleLead from './SingleLead.vue';
import useSingleLeadQuery from '@/composables/useSingleLeadQuery';
import UserMenu from './UserMenu.vue';

export default {
  name: 'Header',
  components: {
    VersionUpdates,
    Notification,
    RemindersMenu,
    ReportsMenu,
    Reminder,
    Alert,
    SingleLead,
    UserMenu,
  },
  setup() {
    const { reminders, getUserReminders } = useReminderQuery;
    const { user } = useCurrentUser();
    const { showSingleLead } = useSingleLeadQuery;

    getUserReminders();

    return { reminders, user, showSingleLead };
  },
  data() {
    return {
      showRemindersMenu: false,
      showVersionUpdates: false,
      hasShownReminders: false,
      showReminder: null,
      showReportsMenu: false,
      showUserMenu: false,
    };
  },
  computed: {
    sortedReminders() {
      if (!this.reminders) return [];
      return this.reminders.filter((reminder) => !reminder.COMPLETED).sort((a, b) => a.DATE - b.DATE);
    },
  },
  watch: {
    sortedReminders() {
      if (this.sortedReminders.length && !this.hasShownReminders) {
        this.hasShownReminders = true;
        this.showRemindersMenu = true;
      }
    },
  },
  methods: {
    refreshPage() {
      location.reload();
    },
    goBack() {
      history.back();
    },
    selectReminder(reminderid) {
      this.showReminder = reminderid;
      this.showRemindersMenu = false;
    },
  },
};
</script>

<style lang="scss" scoped>
header {
  background-color: $headerBackground;
  height: $heightOfHeader;
  display: flex;
  flex-direction: row;

  .logo {
    background-image: url(../assets/logo.png);
    background-repeat: no-repeat;
    width: 150px;
    margin: 13px;
    margin-left: 20px;
    height: 43px;
    background-size: contain;
  }

  .nav-center {
    display: flex;
    flex-direction: row;
    flex: 1;

    .nav-actions {
      display: flex;
      flex-direction: row;
      margin-left: 30px;
      user-select: none;

      img {
        margin-right: 17px;
        padding-top: 25px;
        padding-bottom: 15px;
        cursor: pointer;
        &:last-child {
          margin-right: 34px;
        }
      }
    }

    span {
      padding: 15px;
      padding-top: 30px;
      padding-bottom: 20px;
      font-size: 16px;
      color: white;
      text-decoration: none;
      text-transform: uppercase;
      cursor: pointer;
      user-select: none;

      &.active {
        border-bottom: 6px solid #3eb35a;
      }
    }
  }

  .nav-right {
    display: flex;
    flex-direction: row;
    user-select: none;
    margin-right: 1rem;
    gap: 1rem;
    height: 100%;
    align-items: center;

    span {
      margin-top: 30px;
      margin-right: 40px;
      a {
        font-size: 15px;
        color: white;
        text-decoration: none;
        vertical-align: top;
        &:hover {
          text-decoration: underline;
        }
      }
    }
    .icon-container {
      position: relative;
    }

    img {
      cursor: pointer;
      margin-top: 0.4rem;
      width: 2.1rem;
      height: 2.1rem;
    }
  }
}

.dropdown-toggle {
  position: relative;
}

@media print {
  header {
    display: none !important;
  }
}
</style>
